import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { reportDeduction, exportExcelDeductionReport } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportDeductionStore {
  pageDataDeduction = new PageResponse();
  searchReportDeduction = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: null,
    patientTransactionCategories: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchDeduction = (searchReportDeduction) => {
    this.searchReportDeduction = {
      ...this.searchReportDeduction,
      ...searchReportDeduction,
    };
    this.pagingReportDeduction();
  };

  pagingReportDeduction = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportDeduction.departmentIds || this.searchReportDeduction.departmentIds.length === 0) {
      this.pageDataDeduction = new PageResponse();
      return;
    }
    
    let searchObj = this.normalizeSearchReport(this.searchReportDeduction);

    return await reportDeduction({ ...searchObj })
      .then(({ data }) => {
        this.pageDataDeduction = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo trừ nợ có lỗi");
      });
  };

  handleExportExcelDeduction = async () => {
    if (!this.searchReportDeduction.departmentIds || this.searchReportDeduction.departmentIds.length === 0) {
      toast.warning("Vui lòng chọn cơ sở trước khi xuất excel");
      return;
    }
    const searchObj = this.normalizeSearchReport(this.searchReportDeduction);
    try {
      const response = await exportExcelDeductionReport(searchObj);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_TRU_TIEN_THE_COC.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
      toast.error("Có lỗi xảy ra khi xuất Excel");
    }
  };

  normalizeSearchReport = (rawSearch = {}) => {
    const { departmentIds, patientTransactionCategories, keyword, ...rest } =
      rawSearch;
    return {
      ...rest,
      departmentIds:
        departmentIds?.length > 0 ? departmentIds?.map((el) => el?.id) : null,
      patientTransactionCategories:
        patientTransactionCategories?.length > 0
          ? patientTransactionCategories?.map((el) => el?.value)
          : null,
      keyword: keyword ? keyword : null,
    };
  };

  resetStore = () => {};
}
